import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';

import settingsModule from './modules/settings';
import authorizationModule from './modules/authorization';

import settingsMixin from './mixins/store-settings';

Vue.use(Vuex);
Vue.mixin(settingsMixin);

const vuexLocal = new VuexPersistence({
  key: 'devo',
  storage: window.storage,
});

const store = new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  state: {
  },
  modules: {
    settings: settingsModule,
    authorization: authorizationModule,
  },
  plugins: [vuexLocal.plugin],
});

export default store;
